import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { projectFirestore } from "../../firebase-config/config";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { useState, useEffect } from "react";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useParams } from "react-router-dom";
import "./ProductSettings.scss";
import { MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import Modal from "@mui/material/Modal";
import ReactSwitch from "react-switch";
import MuiAlert from "@mui/material/Alert";
import { Snackbar } from "@mui/material";
import { Box, TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useCollection } from "../../firebase-files/hooks/useCollection";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};
const ProductSettings = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { id } = useParams();

  const [snackbarOpen, setSnackbarOpen] = useState(false); // State for snackbar
  const [snackbarMessage, setSnackbarMessage] = useState(""); // State for snackbar message

  const { updateDocument } = useFirestore("products");
  const { document, error } = useDocument("products", id);
  const { document: TAXDocument } = useDocument("settings", "tax_GST");
  const { documents: vendors } = useCollection("vendors");

  useEffect(() => {
    // Fetch document data and set editedName
    if (document || TAXDocument) {
      setIsColorVisible(document.showColors || false);
      setIsSizeVisible(document.showSizes || false);
      setIsVariantVisible(document.showVariants || false);
      // const taxData = {
      //   gst: document.gst || TAXDocument.gst || "",
      //   sgst: document.sgst || TAXDocument.sgst || "",
      //   cgst: document.cgst || TAXDocument.cgst || "",
      //   cess: document.cess || TAXDocument.cess || "",
      // };

      setProductGST(document?.gst ?? TAXDocument?.gst ?? "");
      setProductSGST(document?.sgst ?? TAXDocument?.sgst ?? "");
      setProductCGST(document?.cgst ?? TAXDocument?.cgst ?? "");
      setProductCESS(document?.cess ?? TAXDocument?.cess ?? "");
      // setOriginalTaxData(taxData);
    }
  }, [document, TAXDocument]);

  // START CODE FOR CHANGE PRODUCT STATUS
  const [checked, setChecked] = useState();
  const handleStatusToggleChange = (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    updateDocument(id, { status: newStatus })
      .then(() => {
        setChecked(newStatus === "active");
      })
      .catch((error) => {
        console.error("Error updating product status:", error);
      });
  };
  // END CODE FOR CHANGE PRODUCT STATUS

  //   START CODE FOR MANAGE QUANTITY
  const [isQuantityModalOpen, setIsQuantityModalOpen] = useState(false);
  const [quantityForm, setQuantityForm] = useState({
    maxQuantity: "",
    minQuantity: "",
    stock: "",
  });

  useEffect(() => {
    if (document) {
      setQuantityForm({
        maxQuantity: document?.maxQuantity || "",
        minQuantity: document?.minQuantity || "",
        stock: document?.stock || "",
      });
    }
  }, [document]);

  const handleQuantityFormChange = (e) => {
    const { name, value } = e.target;
    setQuantityForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Add this handler to save quantity settings
  const handleSaveQuantity = async () => {
    try {
      await updateDocument(id, {
        maxQuantity: parseInt(quantityForm.maxQuantity),
        minQuantity: parseInt(quantityForm.minQuantity),
        stock: parseInt(quantityForm.stock),
      });
      setIsQuantityModalOpen(false);
      setSnackbarMessage("Quantity settings updated successfully");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating quantity settings:", error);
      setSnackbarMessage("Error updating quantity settings");
      setSnackbarOpen(true);
    }
  };
  //   END CODE FOR MANAGE QUANTITY

  //   START CREATE DUPLICATE PRODUCT
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [copyProductForm, setCopyProductForm] = useState({
    name: "",
    price: "",
    discount: "",
  });
  const [selectedVendors, setSelectedVendors] = useState([]);

  // Convert vendors to react-select options
  const vendorOptions = vendors
    ? [
        { value: "all", label: "All Vendors" },
        ...vendors.map((v) => ({
          value: v.id,
          label: v.name,
        })),
      ]
    : [];
  console.log("vendors raw:", vendors);
  console.log("vendorOptions:", vendorOptions);

  // Add this function to handle form reset
  const resetCopyForm = () => {
    setSelectedRole("");
    setCopyProductForm({
      name: "",
      price: "",
      discount: "",
    });
  };

  // Add this function to handle form changes
  const handleCopyFormChange = (e) => {
    const { name, value } = e.target;
    setCopyProductForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle radio change
  const handleRoleChange = (e) => {
    setSelectedRole(e.target.value);
    // When role is selected, pre-fill the form with current product details
    setCopyProductForm({
      name: document?.name,
      price: document?.price,
      discount: document?.discount,
    });
  };
  // Handle copy product
  const handleCopyProduct = async () => {
    try {
      const newProductData = {
        ...document,
        id: null,
        name: copyProductForm.name,
        brand: document?.brand || "", // Add brand
        model: document?.model || "", // Add model
        sku: document?.sku || "", // Add SKU
        hsn: document?.hsn || "", // Add HSN
        price: copyProductForm.price,
        discount: copyProductForm.discount,
        buyerType: selectedRole,
        showProductTo: selectedVendors.map((v) => v.value),
        createdAt: new Date(),
        images: [
          "https://firebasestorage.googleapis.com/v0/b/smart-wash-80a57.appspot.com/o/master_data%2Fproduct_default_img%2Fimages.jfif?alt=media&token=14ec16c1-dab0-4bae-a086-63bf9ecbd967",
        ],
      };
      console.log("created object", newProductData);

      delete newProductData.id;

      // Add the new product to Firestore
      const newProductRef = await projectFirestore
        .collection("products")
        .add(newProductData);
      console.log("created object", newProductRef);

      setIsCopyModalOpen(false);
      resetCopyForm();

      setSnackbarMessage("Product copied successfully");
      setSnackbarOpen(true);

      // Navigate to new product
      navigate(`/product-details-two/${newProductRef.id}`);
    } catch (error) {
      console.error("Error copying product:", error);
      setSnackbarMessage("Error copying product");
      setSnackbarOpen(true);
    }
  };
  //   END CREATE DUPLICATE PRODUCT

  //   START CODE FOR UPDATE/EDIT COLOR, SIZE,VARIENTS
  const [isColorVisible, setIsColorVisible] = useState(false);
  const [isSizeVisible, setIsSizeVisible] = useState(false);
  const [isVariantVisible, setIsVariantVisible] = useState(false);

  const handleColorVisibilityToggle = async () => {
    const newVisibility = !isColorVisible;
    setIsColorVisible(newVisibility);
    try {
      await updateDocument(id, { showColors: newVisibility });
    } catch (error) {
      console.error("Error updating color visibility:", error);
    }
  };

  const handleSizeVisibilityToggle = async () => {
    const newVisibility = !isSizeVisible;
    setIsSizeVisible(newVisibility);
    try {
      await updateDocument(id, { showSizes: newVisibility });
    } catch (error) {
      console.error("Error updating size visibility:", error);
    }
  };

  const handleVariantVisibilityToggle = async () => {
    const newVisibility = !isVariantVisible;
    setIsVariantVisible(newVisibility);
    try {
      await updateDocument(id, { showVariants: newVisibility });
    } catch (error) {
      console.error("Error updating variant visibility:", error);
    }
  };
  //   END CODE FOR UPDATE/EDIT COLOR, SIZE,VARIENTS

  // START CODE FOR CHANGE PRODUCTS POPULARITY
  const [checkedTopSelling, setCheckedTopSelling] = useState(false);
  const [checkedPopular, setCheckedPopular] = useState(false);
  const [checkedNewArrivals, setCheckedNewArrivals] = useState(false);
  const [isShippingAllow, setIsShippingAllow] = useState(false);
  const handlePopularityToggleChange = (fieldName, currentStatus) => {
    const newStatus = !currentStatus; // Toggle the current boolean status
    // Update the status in Firestore
    updateDocument(id, { [fieldName]: newStatus })
      .then(() => {
        switch (fieldName) {
          case "topSellingProducts":
            setCheckedTopSelling(newStatus);
            break;
          case "popularProducts":
            setCheckedPopular(newStatus);
            break;
          case "newArrivals":
            setCheckedNewArrivals(newStatus);
            break;
          case "isShippingAllow":
            setIsShippingAllow(newStatus);
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        console.error("Error updating product status:", error);
      });
  };
  // END CODE FOR CHANGE PRODUCTS POPULARITY

  //   TAXES CODE START
  const [productGST, setProductGST] = useState("");
  const [productSGST, setProductSGST] = useState("");
  const [productCGST, setProductCGST] = useState("");
  const [productCESS, setProductCESS] = useState("");

  const handleSaveClick = async () => {
    await updateDocument(id, {
      gst: productGST,
      sgst: productSGST,
      cgst: productCGST,
      cess: productCESS,
    });
    setSnackbarMessage("TAX updated successfully");
    setSnackbarOpen(true);
  };
  //   TAXES CODE END

  //   START CODE FOR SNACKBAR
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false); // Close snackbar
  };
  //   END CODE FOR SNACKBAR

  const handleVendorSelection = (selectedOptions) => {
    // If nothing selected
    if (!selectedOptions || selectedOptions.length === 0) {
      setSelectedVendors([]);
      return;
    }

    // Find if "All Vendors" is selected
    const allSelected = selectedOptions.some((item) => item.value === "all");

    if (allSelected) {
      // If "All Vendors" selected → keep ONLY "all"
      setSelectedVendors([{ value: "all", label: "All Vendors" }]);
    } else {
      // If other vendors selected → remove "all"
      const filtered = selectedOptions.filter((item) => item.value !== "all");
      setSelectedVendors(filtered);
    }
  };

  return (
    <div className="product-settings-compo-main-div">
      {/* MODEL FOR DUPLICATE PRODUCT */}
      <Modal
        open={isCopyModalOpen}
        onClose={() => {
          setIsCopyModalOpen(false);
          resetCopyForm();
        }}
        className="copy-modal-main-div"
      >
        <Box sx={modalStyle}>
          <h2 id="copy-modal-title">Copy Product</h2>
          <div className="copy-modal-content">
            <div className="role-selection">
              <p>Select Role:</p>
              <div className="radio-group">
                {["dealer", "retailer", "customer"].map((role) => (
                  <label key={role} className="radio-label">
                    <input
                      type="radio"
                      name="copyRole"
                      value={role}
                      checked={selectedRole === role}
                      onChange={handleRoleChange}
                    />
                    <span className="radio-text">
                      {role.charAt(0).toUpperCase() + role.slice(1)}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {selectedRole && (
              <div className="copy-form">
                <TextField
                  label="Product Name"
                  name="name"
                  value={copyProductForm.name}
                  onChange={handleCopyFormChange}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="Price"
                  name="price"
                  type="number"
                  value={copyProductForm.price}
                  onChange={handleCopyFormChange}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="Discount"
                  name="discount"
                  value={copyProductForm.discount}
                  onChange={handleCopyFormChange}
                  fullWidth
                  margin="normal"
                  placeholder="e.g., 10%"
                />
                <Select
                  isMulti
                  options={vendorOptions}
                  value={selectedVendors}
                  onChange={handleVendorSelection}
                  className="vendor-multiselect"
                  classNamePrefix="vendor-select"
                  placeholder="Select vendors..."
                />
              </div>
            )}

            <div className="modal-actions">
              <Button
                variant="outlined"
                onClick={() => {
                  setIsCopyModalOpen(false);
                  resetCopyForm();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleCopyProduct}
                disabled={
                  !selectedRole ||
                  !copyProductForm.name ||
                  !copyProductForm.price
                }
              >
                Create Copy
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      {/* END MODEL FOR DUPLICATE PRDUCT */}
      {(user?.role === "admin" || user?.role === "superAdmin") && (
        <div className="row mb-4">
          <div className="col-12">
            <MDBCard className="admin-controls-card">
              <MDBCardBody>
                <div className="mb-4 d-flex justify-content-between align-items-center">
                  <h5>Product Settings</h5>
                  <button
                    className="copy-button"
                    onClick={() => {
                      setIsCopyModalOpen(true);
                      // Pre-fill form with current product details
                      setCopyProductForm({
                        name: document?.name,
                        price: document?.price,
                        discount: document?.discount,
                        buyerType: document?.buyerType,
                      });
                    }}
                    title="Create copy of product"
                  >
                    Duplicate Product
                  </button>
                </div>

                <div className="admin-controls-grid">
                  {/* Product Status Section */}
                  <div className="control-section">
                    <div className="control-section-part">
                      <div className="section-header">
                        <h6 className="section-title">Product Status</h6>
                      </div>
                      <div className="toggle-group">
                        <div className="toggle-item">
                          <span className="toggle-label">Status</span>
                          <div className="toggle-control">
                            <span
                              className={`status-label ${
                                document?.status !== "active" ? "active" : ""
                              }`}
                            >
                              Inactive
                            </span>
                            <ReactSwitch
                              checked={document?.status === "active"}
                              onChange={() =>
                                handleStatusToggleChange(
                                  document?.id,
                                  document?.status
                                )
                              }
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                              // className="products-status-switch"
                            />
                            <span
                              className={`status-label ${
                                document?.status === "active" ? "active" : ""
                              }`}
                            >
                              Active
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="control-section-part">
                      <div className="section-header">
                        <h6 className="section-title">Quantity Management</h6>
                      </div>
                      <div
                        className="toggle-group"
                        onClick={() => setIsQuantityModalOpen(true)}
                      >
                        <div className="toggle-item">
                          <span className="toggle-label">
                            Manage Quantity Settings
                          </span>
                          <span className="material-symbols-outlined">
                            arrow_forward
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Product Type Section */}
                  <div className="control-section">
                    <h6 className="section-title">Show Product To</h6>
                    <div className="radio-group">
                      {["dealer", "retailer", "customer"].map((role) => (
                        <div key={role} className="radio-label-container">
                          <label className="radio-label">
                            <input
                              type="radio"
                              name="buyerType"
                              value={role}
                              checked={document?.buyerType === role}
                              onChange={async (e) => {
                                try {
                                  await updateDocument(id, {
                                    buyerType: e.target.value,
                                  });
                                } catch (error) {
                                  console.error(
                                    "Error updating buyer type:",
                                    error
                                  );
                                }
                              }}
                            />
                            <span className="radio-text">
                              {role.charAt(0).toUpperCase() + role.slice(1)}
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Product Features Section */}
                  <div className="control-section">
                    <h6 className="section-title">Product Features</h6>
                    <div className="toggle-group">
                      <div className="toggle-item">
                        <span className="toggle-label">Color Options</span>
                        <ReactSwitch
                          checked={isColorVisible}
                          onChange={handleColorVisibilityToggle}
                          onColor="#149AA2"
                          offColor="#F05B83"
                          className="products-status-switch"
                        />
                      </div>

                      <div className="toggle-item">
                        <span className="toggle-label">Size Options</span>
                        <ReactSwitch
                          checked={isSizeVisible}
                          onChange={handleSizeVisibilityToggle}
                          onColor="#149AA2"
                          offColor="#F05B83"
                          className="products-status-switch"
                        />
                      </div>
                      <div className="toggle-item">
                        <span className="toggle-label">Variants</span>
                        <ReactSwitch
                          checked={isVariantVisible}
                          onChange={handleVariantVisibilityToggle}
                          onColor="#149AA2"
                          offColor="#F05B83"
                          className="products-status-switch"
                        />
                      </div>
                      <div className="toggle-item">
                        <span className="toggle-label">Allow Shipping</span>
                        <ReactSwitch
                          checked={document?.isShippingAllow === true}
                          onChange={() =>
                            handlePopularityToggleChange(
                              "isShippingAllow",
                              isShippingAllow
                            )
                          }
                          onColor="#149AA2"
                          offColor="#F05B83"
                          className="products-status-switch"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Product Categories Section */}
                  <div className="control-section">
                    <div className="section-header">
                      <h6 className="section-title">Product Categories</h6>
                    </div>
                    <div className="toggle-group">
                      <div className="toggle-item">
                        <span className="toggle-label">Top Selling</span>
                        <ReactSwitch
                          checked={document?.topSellingProducts === true}
                          onChange={() =>
                            handlePopularityToggleChange(
                              "topSellingProducts",
                              checkedTopSelling
                            )
                          }
                          onColor="#149AA2"
                          offColor="#F05B83"
                          className="products-status-switch"
                        />
                      </div>
                      <div className="toggle-item">
                        <span className="toggle-label">Popular Items</span>
                        <ReactSwitch
                          checked={document?.popularProducts === true}
                          onChange={() =>
                            handlePopularityToggleChange(
                              "popularProducts",
                              checkedPopular
                            )
                          }
                          onColor="#149AA2"
                          offColor="#F05B83"
                          className="products-status-switch"
                        />
                      </div>
                      <div className="toggle-item">
                        <span className="toggle-label">New Arrival</span>
                        <ReactSwitch
                          checked={document?.newArrivals === true}
                          onChange={() =>
                            handlePopularityToggleChange(
                              "newArrivals",
                              checkedNewArrivals
                            )
                          }
                          onColor="#149AA2"
                          offColor="#F05B83"
                          className="products-status-switch"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Start Product GST Card */}
                  <div className="control-section">
                    <div className="section-header">
                      <h6 className="section-title">Product Taxes</h6>
                    </div>
                    <TextField
                      variant="outlined"
                      type="number"
                      label="GST"
                      value={productGST}
                      onChange={(e) => setProductGST(e.target.value)}
                      fullWidth
                      margin="normal"
                      placeholder="example 18%"
                    />
                    <TextField
                      variant="outlined"
                      type="number"
                      label="SGST"
                      value={productSGST}
                      onChange={(e) => setProductSGST(e.target.value)}
                      fullWidth
                      margin="normal"
                      placeholder="example 6%"
                    />
                    <TextField
                      variant="outlined"
                      type="number"
                      label="CGST"
                      value={productCGST}
                      onChange={(e) => setProductCGST(e.target.value)}
                      fullWidth
                      margin="normal"
                      placeholder="example 6%"
                    />

                    <TextField
                      variant="outlined"
                      type="number"
                      label="CESS"
                      value={productCESS}
                      onChange={(e) => setProductCESS(e.target.value)}
                      fullWidth
                      margin="normal"
                      placeholder="example 6%"
                    />
                    <button
                      className="btn_fill"
                      onClick={() => handleSaveClick("gst")}
                      style={{ marginTop: "8px" }}
                    >
                      Save Tax
                    </button>
                  </div>
                </div>
              </MDBCardBody>
            </MDBCard>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{
            width: "120%",
            backgroundColor: "white",
            border: "1px solid black",
          }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* MODEL FOR MANAGE QUANTITY */}
      <Modal
        open={isQuantityModalOpen}
        onClose={() => setIsQuantityModalOpen(false)}
        aria-labelledby="quantity-modal-title"
      >
        <Box sx={modalStyle}>
          <h2 id="quantity-modal-title">Quantity Settings</h2>
          <div className="quantity-modal-content">
            <TextField
              label="Maximum Order Quantity"
              name="maxQuantity"
              type="number"
              value={quantityForm.maxQuantity}
              onChange={handleQuantityFormChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Minimum Order Quantity"
              name="minQuantity"
              type="number"
              value={quantityForm.minQuantity}
              onChange={handleQuantityFormChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Available Stock"
              name="stock"
              type="number"
              value={quantityForm.stock}
              onChange={handleQuantityFormChange}
              fullWidth
              margin="normal"
            />
          </div>
          <div className="modal-actions">
            <Button
              variant="outlined"
              onClick={() => setIsQuantityModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveQuantity}
              disabled={
                !quantityForm.maxQuantity ||
                !quantityForm.minQuantity ||
                !quantityForm.stock
              }
            >
              Save Settings
            </Button>
          </div>
        </Box>
      </Modal>
      {/* END FOR MANAGE QUANTITY */}
    </div>
  );
};

export default ProductSettings;
